import './lib/types/global'

import './css/base.css'

import mixpanel from './modules/mixpanel'
import drawer from './modules/drawer'
import filterbar from './modules/filterbar'
import search from './modules/search'
import sorting from './modules/sorting'
import carousels from './modules/carousels'
import wasteMetrics from './modules/wasteMetrics'
import klaviyoSignup from './modules/klaviyoSignup'
import validation from './modules/validation'
import announcements from './modules/announcements'
import lazyImages from './modules/lazyImages'
import header from './modules/header'
import emailCaptureDiscount from './modules/emailCaptureDiscount'
import cartLogic from './modules/cartLogic'
import countdown from './modules/countdown'
import waitlistCountdown from './modules/waitlistCountdown'
import faqAnalytics from './modules/faqAnalytics'
import starterKitContents from './modules/starterKitContents'
import verticalContent from './modules/verticalContent'
import autoDiscount from './modules/autoDiscount'
import trustpilotStars from './modules/trustpilotStyleStarRating'
import detailsAccordian from './modules/detailsAccordian'
import trustpilotHighlights from '@/modules/trustpilotHighlights'
import quotesCarousel from '@/modules/quoteCarousel'

import { createApp } from 'vue'
import CartApp from '@/apps/CartApp.vue'
import NavigationApp from '@/apps/NavigationApp.vue'
import LoginApp from '@/apps/LoginApp.vue'

mixpanel()
drawer()
filterbar()
search()
sorting()
carousels()
wasteMetrics()
klaviyoSignup()
validation()
announcements()
lazyImages()
header()
emailCaptureDiscount()
cartLogic()
countdown()
waitlistCountdown()
faqAnalytics()
starterKitContents()
verticalContent()
autoDiscount()
trustpilotStars()
detailsAccordian()
trustpilotHighlights()
quotesCarousel()

const cartElement = document.querySelector('#bower-cart') as HTMLElement | null
if (cartElement) {
  createApp(CartApp).mount(cartElement)
}

const navigationElements = document.querySelectorAll(
  '[data-nav-app-root]',
) as NodeList

if (navigationElements.length) {
  for (const navigationElement of navigationElements) {
    const navigationElementAsHtml = navigationElement as HTMLElement
    const structure = navigationElementAsHtml.getAttribute(
      'data-nav-structure',
    ) as string
    const settings = navigationElementAsHtml.getAttribute(
      'data-nav-settings',
    ) as string
    createApp(NavigationApp, {
      navStructure: JSON.parse(structure),
      settings: JSON.parse(settings),
      type: navigationElementAsHtml.getAttribute('data-nav-type') as string,
    }).mount(navigationElement as HTMLElement)
  }
}

const loginElement = document.querySelector('#login-root') as HTMLElement | null
if (loginElement) {
  createApp(LoginApp).mount(loginElement)
}
